import { Button } from '@welbe/design-system';
import { Pencil } from 'App/assets/icons';
import { Status } from 'App/Components/Status/Status';
import { DoctorNameLabel } from 'App/Components/TitleSelector/TitleSelector';
import { Counter } from '../Counter/Counter';
import { StatusSwitch } from '../UsersTable/StatusSwitch';

const setBranchOfficeField = (row: any) => {
	if (!row.firstBranchOffice) return '-';
	return (
		<Counter
			key={row.id}
			firstBranchOffice={row.firstBranchOffice}
			remainingBranchOfficesCount={row.remainingBranchOfficesCount}
		/>
	);
};

export const formattedRows = (
	data: any,
	handleSelectUser: (row: any) => void,
	handleToggleStatus: (id: string, status: boolean) => Promise<void>,
) => {
	return (
		data?.map((row: any) => ({
			id: row.id,
			name: <DoctorNameLabel title={row.title} name={row.name} />,
			branchOffice: setBranchOfficeField(row),
			status: <Status key={row.status} status={row.status} />,
			userStatus: (
				<StatusSwitch
					key={row.status}
					id={row.id}
					status={row.status}
					onToggle={handleToggleStatus}
				/>
			),
			edit: (
				<Button variant="ghost" onClick={() => handleSelectUser(row)}>
					<Pencil />
				</Button>
			),
		})) ?? []
	);
};
